export function isValueOfNone(valueOrIdOrName: string, additional = false): boolean {
  let emptyValues = ['keine?', 'ohne'];
  if (additional) {
    emptyValues = [...emptyValues, 'na', 'nv', 'auswählen', 'leer'];
  }
  // Found examples:
  // keine, keine_Normtuer, keine Amrum, 1_keine_Verglasung, ohne, 1_Ohne,
  // Filter.Zarge.Oberteil.Oberblende_ohne_Kaempfer
  // Regex:
  // starts with kein, keine, ohne or has them follow after any non a-z 0-9 character
  // ends afterwards or has any non a-z 0-9 character following afterwards
  // Flags: ignore case
  // Link for testing: https://regex101.com/r/15dQ0J/1
  const regex = new RegExp(`(?:^|[^a-z0-9]+)(?:${emptyValues.join('|')})(?:[^a-z0-9]+|$)`, 'i');

  return regex.test(valueOrIdOrName);
}
